import { render, staticRenderFns } from "./jpb_3.vue?vue&type=template&id=1a8835ca&"
import script from "./jpb_3.vue?vue&type=script&lang=js&"
export * from "./jpb_3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports